/* eslint-disable */
import {
  AES, enc, mode, pad,
} from 'crypto-js';

export default class CryptoService {
  encryptString = (str: string) => {
    const key = enc.Utf8.parse('greenstone706173');
    const iv = enc.Utf8.parse('greenstone706173');

    return AES.encrypt(
      str,
      key,
      {
        keySize: 128 / 8,
        iv,
        mode: mode.CBC,
        padding: pad.Pkcs7,
      },
    ).toString();
  };

  dencryptString(str: string) {
    if (!str) {
      return '';
    }
    const key = enc.Utf8.parse('greenstone706173');
    const iv = enc.Utf8.parse('greenstone706173');
    return enc.Utf8.stringify(AES.decrypt(
      str,
      key,
      {
        keySize: 128 / 8,
        iv,
        mode: mode.CBC,
        padding: pad.Pkcs7,
      },
    ));
  }
}
